import React from "react";
import { useAppSelector } from "../store/hooks";
import { selectUserDetails } from "../userSlice";

interface Props {
  handleNext: () => void;
}
const Review = ({ handleNext }: Props) => {
  const details = useAppSelector(selectUserDetails);

  // handling the continuation feature
  return (
    <>
      <div className="flex justify-center ">
        <div className=" bg-white mt-16 mb-6 container rounded-md p-8 lg:w-2/5">
          <h1 className="text-lg font-medium text-blue-dark">
            Review details of your transfer
          </h1>
          <hr className=" border-grey-light my-5" />
          <div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim">You send</span>
              <span className="text-sm text-base text-black-light font-normal">
                {details.sendTo} {details.fromCurrency}
              </span>
            </div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim">
                Total fees (included)
              </span>
              <span className="text-sm text-black-light font-normal">
                1.52 USD
              </span>
            </div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim">
                Amount we’ll convert
              </span>
              <span className="text-sm text-black-light font-normal">
                {details.aftercharges} {details.fromCurrency}
              </span>
            </div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim">Guaranteed rate</span>
              <span className="text-sm text-black-light font-normal">
                {details.exchangeRate}
              </span>
            </div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim capitalize">
                {details.fullName}
              </span>
              <span className="text-base text-black-light font-normal">
                {details.receiveFrom.toFixed(2)} {details.toCurrency}
              </span>
            </div>
          </div>
          <hr className=" border-grey-light  my-6" />
          <div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim">Name</span>
              <span className="text-sm text-black-light font-normal">
                {details.fullName}
              </span>
            </div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim">Email address</span>
              <span className="text-sm text-black-light font-normal">
                {details.email}
              </span>
            </div>
            <div className="flex justify-between my-1 py-2">
              <span className="text-sm text-grey-dim">
                IBAN / Account number
              </span>
              <span className="text-sm text-black-light font-normal">
                {details.iban}
              </span>
            </div>
          </div>
          <div className=" flex justify-between mt-6">
            <button
              type="submit"
              className="h-12 bg-gray-200 w-full rounded text-sm text-white bg-green"
              disabled
            >
              Confirm and continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
